import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import InputBoxLarge from '../../components/common/InputBox/InputBoxLarge';
import ErrorNotification from '../../components/common/AlertBox/ErrorNotification';
import { fetchFinancialYearById } from '../../services/Localization/FinancialYearService';
import '../../components/common/CommonText.css';
import './FinancialYear.css';

const FinancialYearDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const loadDetail = async () => {
      try {
        const res = await fetchFinancialYearById(id);
        if (res && res.response_code === 1) {
          setData(res.data);
        } else {
          setErrors({ general: "Financial year not found" });
        }
      } catch (err) {
        console.error(err);
        setErrors({ general: "Failed to load financial year details" });
      } finally {
        setLoading(false);
      }
    };
    if (id) loadDetail();
  }, [id]);

  if (loading) {
    return (
      <div className="whole-container">
        <p className="common-text fts-14 ftw-4" style={{ padding: '20px' }}>Loading...</p>
      </div>
    );
  }

  return (
    <div className="whole-container">
      <div className="top-heading">
        <PageHeader
          pageName="Localization /"
          nestedpageName="Financial Year Details"
          linkTo="/financial-year"
        />
      </div>

      <div className="fy-container">
        <ErrorNotification errors={errors} marginBottom="16px" />

        {data && (
          <div className="fy-card">
            <div className="fy-card-header">
              <h2 className="fy-card-title">Financial Year Details</h2>
              <button
                className="fy-edit-btn"
                onClick={() => navigate(`/financial-year/edit/${data.id}`)}
              >
                Edit
              </button>
            </div>

            <div className="fy-form-group">
              <InputBoxLarge
                label="Start Date"
                defaultValue={data.start_date || `${data.start_month}/${data.start_day}`}
                readOnly
              />
            </div>

            <div className="fy-form-group">
              <InputBoxLarge
                label="End Date"
                defaultValue={data.end_date || `${data.end_month}/${data.end_day}`}
                readOnly
              />
            </div>

            <div className="fy-section-title">Selected Countries</div>

            <div className="fy-country-pills-container">
              {data.countries && data.countries.length > 0 ? (
                data.countries.map((country) => (
                  <div key={country.id} className="fy-country-pill">
                    <span>{country.name}</span>
                  </div>
                ))
              ) : (
                <p className="common-text fts-14 gray">No countries selected</p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FinancialYearDetail;
